// extracted by mini-css-extract-plugin
export default {"pageContainer":"TopDeFiApps_pageContainer__mJmdN","appsList":"TopDeFiApps_appsList__pG0rl","appCard":"TopDeFiApps_appCard__kGRid","appImage":"TopDeFiApps_appImage__MWqCr"};